/* eslint-disable no-shadow */
// import Widget2 from './widgets/Widget2';
// import Widget3 from './widgets/Widget3';
// import './MarketingBudget.css'
import { useEffect, useRef, useState } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  AppBar,
  Backdrop,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Icon,
  IconButton,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import { toast } from "react-toastify";
import AddCategoryDialog from "./AddCategoryDialog";
import MarketingBudgetList from "./MarketingBudgetList";
import Widget from "./widgets/Widget";
import MarketingBudgetHeader from "./MarketingBudgetHeader";
import "./MarketingBudget.css";
import MarketingTotalSummary from "./MarketingTotalSummary";
import { useCallback } from "react";
import { RowNode } from "ag-grid-community";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
// import { useNavigate } from 'react-router-dom';

const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.marketingBudget}`;
const urlDelete = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.budgetCategories}`;

const useStyles = makeStyles((theme) => ({
  root: {
    "& .widget": {
      flex: "0 0 410px",
    },
  },
}));

export default function MarketingBudget(props) {
  const classes = useStyles(props);
  const [expanded, setExpanded] = useState("NOLTE FZE DIRECT");
  const [tableName, setTableName] = useState("");
  const [data, setData] = useState([]);
  const [error, setError] = useState();
  const [childEdit, setChildEdit] = useState(false);
  const [newChildName, setNewChildName] = useState("");
  const [openSubcat, setOpenSubcat] = useState("");
  const [selectedYear, setSelectedYear] = useState({
    value: new Date().getFullYear(),
  });
  const ref = useRef(null);
  const elseRef = useRef(null);
  const carouselRef = useRef(null);
  const [isPrevSlideDisabled,setIsPrevSlideDisabled]=useState(true)
  const [isNextSlideDisabled,setIsNextSlideDisabled]=useState(false)
  // const [open, setOpen] = useState(false);
  // const [openCategory, setopenCategory] = useState(false);
  // const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [totalSummaryDialog, setTotalSummaryDialog] = useState(false);
  // const [name, setName] = useState('');
  const [selectedBudget, setSelectedBudget] = useState({
    value: "budgetValues",
    label: "Budget",
  });
  const [loading, setLoading] = useState(false);
  const [backdropOpen, setbackdropOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [newCategory, setNewCategory] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const navigate = useNavigate();
  // const navigate = useNavigate()

  // const handleClickOpen = () => {
  //   if (ref.current.canOpen()) {
  //     setOpen(true);
  //   } else {
  //     setShowErrorDialog(true);
  //   }
  // };

  // const handleCategoryClickOpen = () => {
  //   setopenCategory(true);
  // };

  // const handleDeleteClickOpen = () => {
  //   if (ref.current.canOpen()) {
  //     ref.current.deleteRow();
  //   } else {
  //     setShowErrorDialog(true);
  //   }
  // };

  // const handleClose = () => {
  //   setOpen(false);
  //   setopenCategory(false);
  // };

  // const handleCategoryClose = () => {
  //   setopenCategory(false);
  // };

  // const handleErrorDialogClose = () => {
  //   setShowErrorDialog(false);
  // };

  const changeHandler = (data) => {
    loadDate(data, selectedYear);
  };
  const changeYear = (data) => {
    setSelectedYear(data);
    loadDate(data);
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const loadDate = async (year = selectedYear) => {
    try {
      const list = await OAuthService.getList(
        `${url}/budgetCategoriesByYear/${year.value}`
      );
      const main = list.data;
      setData(main);
      if (!tableName) setTableName(main[0].categoryName);
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };

  useEffect(() => {
    loadDate();
  }, []);

  // useEffect(() => {
  //   if(ref.current) ref.current.refreshGrid()
  // }, [data]);

  const handleSave = async () => {
    let updatedData = data.map((item) => {
      if (item.categoryId === categoryId) {
        return { ...item, categoryName: categoryName };
      } else {
        return item;
      }
    });

    try {
      setLoading(true);
      setbackdropOpen(true);
      await OAuthService.updateData(
        `${url}/editBudgetCategoryByYear`,
        selectedYear.value,
        updatedData
      ).then((res)=>{
        setLoading(false);
        setbackdropOpen(false);
        loadDate();
        setCategoryName("");
        setNewChildName("")
        toast.success("Data Updated Successfully");
      }).catch((e)=>{
        setLoading(false);
        toast.error(e.message);
      });
    } catch (error) {
      setLoading(false);
      setbackdropOpen(false);
      setError(error.message);
      // return true
    }
  };

  const handleUpdate = async (payload, mainIndex, index) => {
    const apiPayload = [...data];
    apiPayload[mainIndex].budgets = payload.budgets;
    // console.log('handleUpdate', payload)
    setData(apiPayload);
    // ref.current.api.setData(apiPayload);
  };

  const handleDelete = async (id) => {
    try {
      await OAuthService.deleteData(urlDelete, id);
      loadDate();
      toast.success("Category Deleted");
    } catch (error) {
      console.log("error", error);
    }
  };

  // function handleNameChange(event) {
  //   ref.current.handleNameChange(event);
  // }

  // function handleCategoryNameChange(event) {
  //   ref.current.handleCategoryNameChange(event);
  // }

  const options = [
    { value: "budgetValues", label: "Budget" },
    { value: "forecastValues", label: "Forecast" },
    { value: "actualValues", label: "Actuals" },
  ];

  const changeBudget = (data) => {
    setSelectedBudget(data);
    if (data.value === "actualValues") {
      ref.current.columnHide(false);
    } else {
      ref.current.columnHide(true);
    }
  };

  const handleTotalSummaryDialogClose = () => {
    setTotalSummaryDialog(false);
  };
  const handleTotalSummary = () => {
    setTotalSummaryDialog(true);
  };

  const onBtExport = () => {
    ref.current.exportBtn();
  };

  const handleBudgetSummary = () => {
    navigate(`/marketingBudget/budget-summary`);
  };

  const handleChildData = async (catIndex, subCatIndex, newName) => {
    let val = data[catIndex]?.subCategories[subCatIndex];
    val.subCategoryId = newName?.toUpperCase();
    val.subCategoryName = newName?.toUpperCase();

    setData(data);
    await handleSave();
    setOpenSubcat("");
    setChildEdit(false);
  };

  const handleNameChange = (e) => {
    let value = e?.target?.value;
    console.log(value);
    setNewChildName(value);
  };
  const items = [
      ...[...data]?.map((item, index) => {
        return (
            <div
                key={item.categoryId}
                className="widget w-full px-16"
            >
              <Widget
                  openEdit={setOpenEdit}
                  openDialog={setOpenDialog}
                  setCategoryName={setCategoryName}
                  setNewCategory={setNewCategory}
                  setCategoryId={setCategoryId}
                  handleDelete={handleDelete}
                  categoryName={item.categoryName}
                  categoryId={item.categoryId}
                  categoryBudget={item.budgets}
                  setTableName={setTableName}
                  handleChange={() => {
                    setExpanded(item.subCategories[0].subCategoryId);
                  }}
              />
            </div>
        )
      }),
        <div className="w-full px-16">
          <Card
              className="relative flex flex-col flex-auto rounded-2xl shadow overflow-hidden items-center justify-center"
              sx={{ height: "150px"}}
          >
            <div className="p-24 pr-12 pb-12">
              <AddCategoryDialog
                  openEdit={openEdit}
                  openDialog={openDialog}
                  setOpenDialog={setOpenDialog}
                  // handleSave={handleSave}
                  oldCategoryName={categoryName}
                  setOldCategoryName={setCategoryName}
                  setOpenEdit={setOpenEdit}
                  loadDate={loadDate}
                  categoryData={data}
                  newCategory={newCategory}
              />
            </div>
          </Card>
      </div>
      ];
  const responsive = {
    0: {
      items: 1
    },
    568: {
      items: 2
    },
    1024: {
      items: 3,
      itemsFit: 'contain'
    },
  };
  return (
      <>
        <div className="w-full">
          <MarketingBudgetHeader
              pageName="Marketing Budget"
              error={error}
              changeHandler={changeHandler}
              changeYear={changeYear}
              selectedYear={selectedYear}
              handleSave={handleSave}
              handleTotalSummary={handleTotalSummary}
              onBtExport={onBtExport}
              handleBudgetSummary={handleBudgetSummary}
          />
          <div className={clsx(classes.root, "flex flex-col md:flex-row sm:p-8")}>
            <div className="flex flex-1 flex-row min-w-0">
              <button
                  disabled={isPrevSlideDisabled}
                  className={`${isPrevSlideDisabled?"cursor-not-allowed text-[#a3a3a3]":"cursor-pointer text-[#ffffff]"}`}
                  onClick={(e) => {
                  carouselRef?.current?.slidePrev(e)
                  }}
              >
                <ArrowBackIosNewOutlinedIcon/></button>
              <div
                  className="flex flex-col sm:flex sm:flex-row mb-16 w-full"
                  style={{flexWrap: "nowrap", overflow: "auto"}}
              >
                <AliceCarousel
                    ref={carouselRef}
                    mouseTracking
                    items={items}
                    responsive={responsive}
                    disableDotsControls
                    disableButtonsControls
                    onSlideChanged={({ isNextSlideDisabled, isPrevSlideDisabled})=> {
                      setIsPrevSlideDisabled(isPrevSlideDisabled)
                      setIsNextSlideDisabled(isNextSlideDisabled)
                    }}
                />
              </div>
              <button
                  disabled={isNextSlideDisabled}
                  className={`${isNextSlideDisabled?"cursor-not-allowed text-[#a3a3a3]":"cursor-pointer text-[#ffffff]"}`}
                  onClick={(e) => carouselRef?.current?.slideNext(e)}
              >
                <ArrowForwardIosOutlinedIcon/>
              </button>
            </div>
          </div>
          <div className="sm:px-8">
            <div
                className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8 pb-16 px-16">
            <Select
              name="budgetSummary"
              value={selectedBudget}
              options={options}
              onChange={changeBudget}
              styles={customStyles()}
            />
            <Button
              onClick={handleSave}
              variant="contained"
              color="warning"
              startIcon={<FuseSvgIcon>heroicons-outline:plus</FuseSvgIcon>}
            >
              Save
            </Button>
          </div>
          {loading ? (
            <>
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={backdropOpen}
              >
                <CircularProgress color="inherit" />
                <Typography className="pl-16">
                  Please wait while the data loads
                </Typography>
              </Backdrop>
            </>
          ) : (
            ""
          )}
          {!!data.length &&
            data.map(
              (item, mainIndex) =>
                tableName === item.categoryName && (
                  <div
                    className={
                      tableName === item.categoryName ? "show" : "hide"
                    }
                    key={item.categoryId}
                  >
                    {item.subCategories.map((subItem, index) => (
                      <div key={subItem.subCategoryId} className="px-16 pb-16">
                        <Dialog
                          open={
                            openSubcat === `${subItem.subCategoryId}` &&
                            childEdit
                          }
                          onClose={() => {
                            setOpenSubcat("");
                            setChildEdit(false);
                          }}
                          fullWidth
                          maxWidth="xs"
                        >
                          <AppBar position="static">
                            <Toolbar className="flex w-full justify-between">
                              <Typography variant="subtitle1" color="inherit">
                                Update Sub Category
                              </Typography>
                              <IconButton
                                onClick={() => {
                                  setOpenSubcat("");
                                  setChildEdit(false);
                                }}
                              >
                                <Icon>close</Icon>
                              </IconButton>
                            </Toolbar>
                          </AppBar>

                          <DialogContent
                            classes={{ root: "p-16 pb-0 sm:p-24 sm:pb-0" }}
                          >
                            <TextField
                              id="name"
                              label="Name"
                              className="mt-8 mb-16"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              value={newChildName}
                              name="Name"
                              onChange={(e) => handleNameChange(e)}
                              variant="outlined"
                              autoFocus
                              required
                              fullWidth
                            />
                          </DialogContent>
                          <DialogActions className="float-right px-8 sm:px-16">
                            <Button
                              onClick={() =>
                                handleChildData(mainIndex, index, newChildName)
                              }
                              variant="contained"
                              color="primary"
                              type="button"
                              disabled={newChildName?.length === 0 || subItem?.subCategoryName === newChildName}
                            >
                              Save
                            </Button>
                          </DialogActions>
                        </Dialog>
                        <Accordion
                          expanded={expanded === `${subItem.subCategoryId}`}
                          onChange={handleChange(`${subItem.subCategoryId}`)}
                        >
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography sx={{ flexShrink: 0 }}>
                              {subItem.subCategoryName}
                            </Typography>
                            <Typography
                              className="pl-16"
                              sx={{ color: "text.secondary" }}
                            >
                              {" "}
                              ({subItem.subCategories?.length} Items)
                            </Typography>
                            <Typography className="ml-auto">
                              <EditIcon
                                onClick={() => {
                                  setChildEdit(true);
                                  setOpenSubcat(`${subItem.subCategoryId}`);
                                  setNewChildName(subItem?.subCategoryName)
                                }}
                              />
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <MarketingBudgetList
                              ref={
                                expanded === `${subItem.subCategoryId}`
                                  ? ref
                                  : elseRef
                              }
                              handleUpdate={(apiPayload) =>
                                handleUpdate(apiPayload, mainIndex, index)
                              }
                              handleSave={handleSave}
                              subItem={subItem}
                              // handleDataChange={(payload = data[index]) => {
                              //   const data = [...data];
                              //   data[index] = payload;
                              //   setData(data);
                              // }}
                              selectedBudget={selectedBudget}
                              // saveGridStateName={"marketingBudgetList-"+ subItem.subCategoryId.replace(/\s/g, "")}
                              // handleClickOpen={handleClickOpen}
                              // handleCategoryClickOpen={handleCategoryClickOpen}
                              // handleDeleteClickOpen={handleDeleteClickOpen}
                            />
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    ))}
                  </div>
                )
            )}
          {/* <MarketingBudgetList /> */}
        </div>
      </div>
      {/* <Dialog open={open || openCategory} onClose={handleClose} fullWidth maxWidth="xs">
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              Add Your Category Name
            </Typography>
            <IconButton onClick={handleClose}>
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <form>
          <DialogContent classes={{ root: 'p-16 pb-0 sm:p-24 sm:pb-0' }}>
            <TextField
              id="name"
              label="name"
              className="mt-8 mb-16"
              InputLabelProps={{
                shrink: true,
              }}
              name="name"
              onChange={handleNameChange}
              variant="outlined"
              autoFocus
              required
              fullWidth
            />
          </DialogContent>
          <DialogActions className="justify-between px-8 sm:px-16">
            <Button
              onClick={() => {
                if (openCategory) {
                  ref.current.addMainRow();
                  handleCategoryClose();
                } else {
                  ref.current.addRow();
                  handleClose();
                }
              }}
              variant="contained"
              color="primary"
              type="button"
            >
              Add
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <Dialog
        open={showErrorDialog}
        onClose={handleErrorDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent sx={{ width: '600px', height: 'auto', alignItems: 'center' }}>
          <DialogContentText id="alert-dialog-description" align="center">
            No row was selected.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleErrorDialogClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog> */}
      <MarketingTotalSummary
        totalSummaryDialog={totalSummaryDialog}
        handleTotalSummaryDialogClose={handleTotalSummaryDialogClose}
        data={data}
      />
    </>
  );
}
